<template>
  <div>
    <div class="order_all">
      <div v-show="this.allGoods.length" class="order_have">
        <ul class="order_all_nav">
          <li>商品画像</li>
          <li>商品名</li>
          <li>商品単価</li>
          <li>商品数量</li>
          <li>注文状態</li>
          <li>設定</li>
        </ul>
        <div class="order_all_main">
          <ul class="all_main_top">
            <li><span><img src="../../assets/images/goods/cart_goods_img.png"></span></li>
            <li><p><span>持续吸收性VB</span></p></li>
            <li><p><span>￥960</span></p></li>
            <li><p><span>X2</span></p></li>
            <li><p><span>未支付</span></p></li>
            <li><p><span><button @click="toCartBuy">買い付けを続ける</button></span></p></li>
          </ul>
          <div class="all_main_footer">
            <span>合计<label>￥960</label></span>
            <span>共计<label>1</label>件商品</span>
          </div>
        </div>
      </div>
      <div v-show="!this.allGoods.length" class="order_no">
        <img src="../../assets/images/personal/wu.png" height="315" width="175"/>
        <span>関連注文はありません。</span>
      </div>
    </div>
    <div class="Poeder_all">
      <div v-show="this.allGoods.length" class="order_Phave">
        <div class="order_all_main">
          <ul class="order_all_nav">
            <li>商品画像</li>
            <li>商品名</li>
            <li>商品単価</li>
            <li>商品数量</li>
            <li>注文状態</li>
          </ul>
          <ul class="all_main_top">
            <li><img src="../../assets/images/goods/cart_goods_img.png"></li>
            <li><p><span>持续吸收型VB</span></p></li>
            <li><p><span>X2</span></p></li>
            <li><p><span>￥960</span></p></li>
            <li><p><span>未支付</span></p></li>
          </ul>
          <p class="all_main_Price">
            <span>小計：<label>￥132</label></span>
            <span>合計 <label>1</label>点</span>
          </p>
          <div class="all_main_footer">
            <span>詳しく調べる</span>
            <span>注文を削除する</span>
          </div>
        </div>
      </div>
      <div v-show="!this.allGoods.length" class="order_pno">
        <img src="../../assets/images/personal/wu.png">
        <span>関連注文はありません。</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue',
        allGoods: [1],
      }
    },
    methods: {
      toCartBuy(){
        this.$router.push({
          path: "/cart/buy",
        })
      },
    },
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .order_all {
      display: none;
    }
    .Poeder_all {
      width: 100%;
      font-size: 14/$default-w+rem;
      .order_Phave {
        .order_all_nav {
          width: 100%;
          height: 20px;
          padding: 5px 0;
          line-height: 20px;
          background-color: $bgcolor;
          li {
            float: left;
            width: 20%;
            text-align: center;
          }
        }
        .order_all_main {
          margin-top: 5px;
          background-color: white;
          .all_main_top {
            width: 100%;
            height: 100px;
            text-align: center;
            li {
              float: left;
              width: 20%;
              height: 100px;
              img {
                width: 90%;
                height: 92px;
                /*margin-top: 5px;*/
                padding: 4% 5%;
              }
              p {
                height: 50px;
                margin-top: 25px;
                display: flex;
                align-items: center;
                span {
                  text-align: center;
                  width: 100%;
                }
              }
            }
          }
          .all_main_Price{
            height: 25px;
            width: 100%;
            line-height: 25px;
            display: flex;
            justify-content: flex-end;
            span{
              display: inline-block;
              margin: 0 15px;
              label{
                color: $navcolor;
                font-size: 16px;
              }
            }
          }
          .all_main_footer {
            height: 40px;
            width: 100%;
            background-color: white;
            border-top: 1px solid #ddd;
            display: flex;
            justify-content: flex-end;
            span {
              display: inline-block;
              text-align: center;
              height: 20px;
              margin-top: 7px;
              line-height: 20px;
              margin-right: 20px;
              padding: 2px 10px;
              border-radius: 25px;
              font-size: 14px;
              letter-spacing: $letter;
            }
            span:nth-child(1) {
              border: 1px solid #7A7A7A;
              color: #7A7A7A;
            }
            span:nth-child(2) {
              border: 1px solid $navcolor;
              color: $navcolor;
            }
          }
        }
      }
      .order_pno {
        margin: 50px auto;
        width: 100%;
        line-height: 200px;
        display: flex;
        font-size: 14px;
        letter-spacing: 2px;
        justify-content: center;
        img {
          width: 100px;
          height: 200px;
        }
      }
    }
  }

  @media screen and(min-width: $P750screen) {
    .order_all {
      width: 100%;
      font-size: 14px;
      .order_have {
        /*min-width: 852px;*/
        .order_all_nav {
          width: 100%;
          height: 20px;
          padding: 10px 0;
          background-color: $bgcolor;
          li {
            float: left;
            width: 16.66%;
            text-align: center;
          }
        }
        .order_all_main {
          margin-top: 5px;
          .all_main_top {
            width: 100%;
            height: 110px;
            li {
              float: left;
              width: 16.66%;
              height: 110px;
              display: flex;
              justify-content:center;
              text-align: center;
              img {
                margin-top: 10px;
              }
              p{
                width: 100%;
                height: 50px;
                margin: 25px 0;
                /*background-color: #faee00;*/
                display: flex;
                align-items: center;
                span{
                  width: 100%;
                  text-align: center;
                }
              }
              button {
                border: none;
                background-color: white;
                outline: none;
              }
            }
          }
          .all_main_footer {
            height: 20px;
            width: 100%;
            background-color: $bgcolor;
            margin-top: 5px;
            padding: 10px 0;
            span {
              float: right;
              margin-right: 20px;
              line-height: 20px;
              label {
                font-size: 20px;
                color: $navcolor;
                padding: 0 5px;
              }
            }
          }
        }
      }
      .order_no {
        margin: 0 auto;
        margin-top: 50px;
        height: 315px;
        width: 100%;
        line-height: 326px;
        display: flex;
        font-size: 18px;
        letter-spacing: 2px;
        justify-content: center;
        a {
          color: $navcolor;
        }
      }
    }
    .Poeder_all {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/personal/order_all.vue